import { DataSourceCalculation } from "../../api/models/DataSource";
import EmissionsFactorTimelineGroup from "./EmissionsFactorTimelineGroup";
import {
    getMostRecentCalculationsPerDate,
    groupEmissionsFactorCalculationsByYear,
} from "./EmissionsFactorTimelineUtils";

type EmissionsFactorTimelineProps = {
    calculations: DataSourceCalculation[];
};

const EmissionsFactorTimeline = ({
    calculations,
}: EmissionsFactorTimelineProps) => {
    const mostRecentCalculationsByDate =
        getMostRecentCalculationsPerDate(calculations);
    const calculationsGroupedByYear = groupEmissionsFactorCalculationsByYear(
        mostRecentCalculationsByDate
    );

    return (
        <>
            {calculationsGroupedByYear.map((calculationGroup, index) => (
                <EmissionsFactorTimelineGroup
                    year={calculationGroup.year}
                    calculations={calculationGroup.calculations}
                    isFirstTimelineGroup={index === 0}
                    isLastTimelineGroup={
                        index === calculationsGroupedByYear.length - 1
                    }
                    key={`calc-group-${calculationGroup.year}`}
                />
            ))}
        </>
    );
};

export default EmissionsFactorTimeline;
